import { DateAttributeProps } from 'Types/Attribute.types'
import { DatePicker } from 'antd/lib'
import React, { useCallback } from 'react'
import './Date.less'
import dayjs from 'dayjs'
import { INPUT_TYPE_DATE_FORMAT } from 'Constants/constants'

const DateAttribute: React.FC<DateAttributeProps> = props => {
    const handleChange = useCallback(
        (_: dayjs.Dayjs | null, dateString: string | string[]) => {
            props.onChange(dateString ? (dateString as string) : undefined)
        },
        [props]
    )

    return (
        <div
            className={`attribute-main ${props.className}`}
            style={{ width: props.width ?? '90%' }}
            data-testid="date-wrapper"
        >
            <span className="attribute-main-title">{props.label}</span>
            <DatePicker
                placeholder="Please enter value"
                format={INPUT_TYPE_DATE_FORMAT}
                value={props.value ? dayjs(props.value, INPUT_TYPE_DATE_FORMAT) : null}
                onChange={handleChange}
                allowClear
                disabled={props.readonly}
            />
        </div>
    )
}

export default DateAttribute
